import React from 'react';
import { useSelector } from 'react-redux';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { PageHeader } from '../../../global/components/layout/page-header';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import ClergyBioChurchReportingReview from '../church-reporting/clergy-bio-church-reporting-review';
import ClergyBioEducationReview from '../education/clergy-bio-education-review';
import ClergyBioMinistriesReview from '../ministries/clergy-bio-ministries-review';
import ClergyBioPersonalInfoReview from '../personal-info/clergy-bio-personal-info-review';
import ClergyBioProfessionalReview from '../professional/clergy-bio-professional-review';
import ClergyBioRelationshipsReview from '../relationships/clergy-bio-relationships-review';
import ClergyBioVolunteerReview from '../volunteer/clergy-bio-volunteer-review';
import ClergyBioEcclesiastical from './clergy-bio-ecclesiastical';
import EcdMessage from './ecd-message';

interface Props {
	basePath: string;
}

function ClergyBioSummary(props: Props) {

	const { basePath } = props;
	const settings = useSelector<TcsmStates, ClergyBioSettings>(state => state.epiProps?.clergyBioSettingsState?.epiContent);

	return (
		<>
			<PageHeader headerText={settings?.summaryTitle} />
			<ContentSpacer>
				<EcdMessage />
			</ContentSpacer>
			<ContentSpacer>
				<WysiwygWithReactLink content={settings?.notice} />
			</ContentSpacer>
			<ClergyBioEcclesiastical settings={settings} />
			<ClergyBioPersonalInfoReview settings={settings} basePath={basePath} />
			<ClergyBioChurchReportingReview settings={settings} basePath={basePath} />
			<ClergyBioRelationshipsReview settings={settings} basePath={basePath} />
			<ClergyBioEducationReview settings={settings} basePath={basePath} />
			<ClergyBioMinistriesReview settings={settings} basePath={basePath} />
			<ClergyBioVolunteerReview settings={settings} basePath={basePath} />
			<ClergyBioProfessionalReview settings={settings} basePath={basePath} />
		</>
	);
}


export default ClergyBioSummary;